export const rules = {
	// Card titles
	"rules.card.rules.title": "Regras",
	"rules.card.pointsAllocation.title": "Atribuição de pontos",
	"rules.card.rulesContinued.title": "Regras (continuação)",
	"rules.card.weeklyPrizes.title": "Estrutura de prémios semanais",

	// Main rules content
	"rules.intro":
		'Todos os termos em maiúsculas utilizados nestas regras (as <strong>"Regras"</strong>) terão a definição que lhes é atribuída nos termos e condições (os <strong>"Termos e Condições"</strong>).',

	"rules.temporary_notice":
		"Por favor, note que os vencedores de prémios durante o período de 19 de dezembro de 2025 a 2 de janeiro de 2026 receberão os seus prémios dentro de 7 (sete) dias a partir de 6 de janeiro de 2026",

	"rules.rule1":
		"Os participantes podem ganhar pontos prevendo corretamente o resultado de cada um dos cinco (5) jogos todas as semanas/rondas (conforme o caso), relevantes para a competição desportiva a que o jogo Betway Scores BW ScorePredict se refere, por exemplo <em>Premier League inglesa</em>, etc. A competição Betway Scores BW Score Predict começará a 11 de março de 2025 e terminará no final da época de futebol 2025/2026.",

	"rules.rule2.main": "Os participantes podem ganhar pontos bónus adicionais prevendo corretamente o seguinte em cada um dos cinco (5) jogos:",
	"rules.rule2.a": "Resultado final correto",
	"rules.rule2.b": "Vencedor correto",
	"rules.rule2.c": "Golos em casa corretos",
	"rules.rule2.d": "Golos fora corretos",
	"rules.rule2.e": "Diferença de golos correta",

	"rules.rule3": "Cada semana/ronda correlaciona-se com as rondas dessa competição desportiva.",

	"rules.rule4":
		"Os pontos são atribuídos da seguinte forma para cada uma das seguintes previsões corretas do Participante todas as semanas/rondas:",

	// Points allocation
	"rules.points.correctScore": "Resultado final correto",
	"rules.points.correctScoreValue": "50",
	"rules.points.correctWinner": "Vencedor correto",
	"rules.points.correctWinnerValue": "5",
	"rules.points.homeGoals": "Golos em casa corretos",
	"rules.points.homeGoalsValue": "5",
	"rules.points.awayGoals": "Golos fora corretos",
	"rules.points.awayGoalsValue": "5",
	"rules.points.goalDifference": "Diferença de golos correta",
	"rules.points.goalDifferenceValue": "5",

	// Continued rules
	"rules.rule5":
		"Os participantes podem fazer alterações às suas previsões a qualquer momento, até 15 minutos antes do pontapé de saída de cada um dos jogos da semana/ronda relevante.",

	"rules.rule6":
		"Todos os utilizadores registados do Betway Scores e/ou BW Scores são elegíveis para jogar Betway Scores BW ScorePredict, no entanto apenas participantes com uma conta Betway verificada, no momento em que os prémios devem ser atribuídos, são elegíveis para ganhar prémios. Alterações nos resultados do jogo conforme o ponto 2. acima que ocorram após a atribuição dos prémios (por exemplo anulação do resultado) não serão consideradas retrospetivamente.",

	"rules.rule7":
		"O Participante qualificado e elegível que terminar a época em primeiro lugar e tiver uma Conta Betway será o vencedor do Grande Prémio da época e ganhará uma viagem para duas (2) pessoas para ver o Arsenal jogar em Londres, incluindo voos (se necessário), alojamento (se necessário) e £500 de dinheiro de bolso.",

	"rules.rule8":
		"Se o vencedor do Grande Prémio da época não conseguir viajar devido a não ter um passaporte válido e/ou visto e/ou qualquer outra limitação, receberá um prémio de €5.000 de saldo em dinheiro, ou o equivalente aproximado em moeda local na data de início da competição (sendo £4.500, R100.000 ou GH₵ 60.000), na sua Conta Betway no final da competição.",

	"rules.rule9":
		"O vencedor do Grande Prémio da época pode optar por não aceitar a experiência e aceitar um prémio de €5.000 de saldo em dinheiro, ou o equivalente aproximado em moeda local na data de início da competição (sendo £4.500, R100.000 ou GH₵ 60.000), na sua Conta Betway.",

	"rules.rule10":
		'Os Prémios Semanais serão atribuídos aos "Top 10" performers todas as semanas/rondas que tenham uma Conta de Apostas Betway válida. Se um performer Top 10 não tiver uma Conta de Apostas Betway, não receberá um Prémio Semanal.',

	"rules.rule11": "Os lugares semanais 1 a 10 ganharão as seguintes quantias de saldo em dinheiro, dependendo da sua região, na sua Conta Betway.",

	"rules.rule12":
		"Os Prémios Semanais serão atribuídos dentro de 7 (sete) dias após a finalização dos resultados dessa semana e o Grande Prémio será atribuído dentro de 7 (sete) dias após a conclusão da competição Betway Scores BW Score Predict.",

	"rules.rule13":
		"Em caso de empate para os Prémios Semanais, o saldo em dinheiro para essa posição (e as posições relevantes abaixo dela que são impactadas pelo empate) será dividido igualmente entre os participantes empatados.",

	"rules.rule14":
		"Em caso de empate para o Grande Prémio, será usado um mecanismo aleatório para selecionar apenas um dos participantes empatados como vencedor do Grande Prémio.",

	// Weekly prize table data
	"rules.weeklyPrizes.position1.eur": "€150",
	"rules.weeklyPrizes.position1.gbp": "£150",
	"rules.weeklyPrizes.position1.zar": "R3000",
	"rules.weeklyPrizes.position1.ghs": "GH₵2000",

	"rules.weeklyPrizes.position2.eur": "€100",
	"rules.weeklyPrizes.position2.gbp": "£100",
	"rules.weeklyPrizes.position2.zar": "R2000",
	"rules.weeklyPrizes.position2.ghs": "GH₵1250",

	"rules.weeklyPrizes.position3.eur": "€75",
	"rules.weeklyPrizes.position3.gbp": "£75",
	"rules.weeklyPrizes.position3.zar": "R1500",
	"rules.weeklyPrizes.position3.ghs": "GH₵1000",

	"rules.weeklyPrizes.position4.eur": "€50",
	"rules.weeklyPrizes.position4.gbp": "£50",
	"rules.weeklyPrizes.position4.zar": "R1000",
	"rules.weeklyPrizes.position4.ghs": "GH₵600",

	"rules.weeklyPrizes.position5.eur": "€40",
	"rules.weeklyPrizes.position5.gbp": "£40",
	"rules.weeklyPrizes.position5.zar": "R800",
	"rules.weeklyPrizes.position5.ghs": "GH₵500",

	"rules.weeklyPrizes.position6.eur": "€30",
	"rules.weeklyPrizes.position6.gbp": "£30",
	"rules.weeklyPrizes.position6.zar": "R600",
	"rules.weeklyPrizes.position6.ghs": "GH₵400",

	"rules.weeklyPrizes.position7.eur": "€20",
	"rules.weeklyPrizes.position7.gbp": "£20",
	"rules.weeklyPrizes.position7.zar": "R400",
	"rules.weeklyPrizes.position7.ghs": "GH₵250",

	"rules.weeklyPrizes.position8.eur": "€15",
	"rules.weeklyPrizes.position8.gbp": "£15",
	"rules.weeklyPrizes.position8.zar": "R300",
	"rules.weeklyPrizes.position8.ghs": "GH₵200",

	"rules.weeklyPrizes.position9.eur": "€10",
	"rules.weeklyPrizes.position9.gbp": "£10",
	"rules.weeklyPrizes.position9.zar": "R200",
	"rules.weeklyPrizes.position9.ghs": "GH₵100",

	"rules.weeklyPrizes.position10.eur": "€10",
	"rules.weeklyPrizes.position10.gbp": "£10",
	"rules.weeklyPrizes.position10.zar": "R200",
	"rules.weeklyPrizes.position10.ghs": "GH₵100",

	// Table headers
	"rules.weeklyPrizes.header.position": "# Por ronda",
	"rules.weeklyPrizes.header.eur": "EUR",
	"rules.weeklyPrizes.header.gbp": "GBP",
	"rules.weeklyPrizes.header.zar": "ZAR",
	"rules.weeklyPrizes.header.ghs": "GHS",
};
